import { Tab, TabGroup, TabList } from '@headlessui/react'
import type { NewsCategoryFragment } from '@/lib/types/datocms/graphql/generated'
import clsx from 'clsx'
import Icon from './svg/icon'

interface NewsTabbedSearchProps {
	currentFilter: string
	onFilterChange: (filter: string) => void
	categories: NewsCategoryFragment[]
	theme: 'light' | 'dark'
	value: string
	onValueChange: (value: string) => void
	defaultCategory: NewsCategoryFragment | null
}

export default function NewsTabbedSearch({
	currentFilter,
	onFilterChange,
	categories,
	theme,
	value,
	onValueChange,
	defaultCategory,
}: Readonly<NewsTabbedSearchProps>) {
	const options = categories.map((category) => ({
		label: category.name,
		value: category.id,
		slug: category.slug,
	}))

	// If there is a default category, move it to the beginning of the array
	if (defaultCategory) {
		const defaultIndex = options.findIndex((opt) => opt.value === defaultCategory.id)
		if (defaultIndex > -1) {
			const [defaultOpt] = options.splice(defaultIndex, 1)
			options.unshift(defaultOpt)
		}
	}

	return (
		<div
			className={clsx(
				'news-tabbed-search relative max-w-screen-2xl mx-auto md:-mt-16 z-10',
				theme === 'light' && 'theme-light'
			)}
		>
			<TabGroup>
				<div className="md:common-x-padding">
					<TabList
						className={clsx(
							'flex divide-x',
							theme === 'light' ? 'divide-white-frosted' : 'divide-blue-light'
						)}
					>
						{options.map((option) => (
							<Tab
								key={option.value}
								className={`tab-button ${currentFilter === option.value && 'active'}`}
								onClick={() => onFilterChange(option.value ?? '')}
								value={option.value}
							>
								{option.label}
							</Tab>
						))}
					</TabList>
					<div
						className={clsx(
							'flex flex-col @3xl:flex-row @3xl:items-center justify-between p-2 rounded-lg rounded-tl-none bg-white',
							currentFilter === 'Parts' && 'hidden'
						)}
					>
						<div className="flex items-center gap-2 px-3 @3xl:px-6 flex-1">
							<Icon icon="Search" className="w-5" />
							<input
								className="w-full py-5 outline-none"
								type="text"
								placeholder="Search"
								value={value}
								onChange={(e) => onValueChange(e.target.value)}
							/>
						</div>
					</div>
				</div>
			</TabGroup>
		</div>
	)
}
